<template>
  <div>
    <!-- <el-button type="primary" @click="useCamera">重置</el-button>
    <el-button type="plain" @click="photoShoot">拍照</el-button> -->
    <el-alert
      :title="httpsAlert"
      type="info"
      :closable="false"
      v-show="httpsAlert !== ''"
    >
    </el-alert>
    <div class="videoImage" ref="faceBox">
      <!-- ios中：
      解决苹果手机video标签直接全屏播放
      只需要在标签里面写上：webkit-playsinline='true'    playsinline='true'
      android中：
      android端部分视频也会存在自动全屏问题，添加：x5-video-player-type="h5-page" -->
      <video
        webkit-playsinline="true"
        playsinline="true"
        x5-video-player-type="h5-page"
        id="videoElement"
        ref="video"
        v-show="videoShow"
      ></video>
      <canvas ref="canvas" id="canvasElement" style="display:none"></canvas>
      <img ref="image" :src="picture" alt="" v-show="pictureShow" />
    </div>
  </div>
</template>

<script>
// let textPx = (document.body.clientWidth * 100) / 720;
import { liveVerify } from "../../utils/api/h5page";
export default {
  name: "Recognize",
  data() {
    return {
      videoShow: true,
      pictureShow: false,
      // 图片地址
      picture: "",
      // 用于视频识别的节点
      canvas: null,
      video: null,
      image: null,
      interval: 0,
      // 模型识别的条件
      options: "",
      // 提示控制
      noOne: "",
      moreThanOne: "",
      // 不是通过Https访问提示
      httpsAlert: "",
    };
  },
  mounted() {
    // 初始化
    setTimeout(() => {
      this.cameraOptions();
    }, 200);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    /**
     * 使用视频来成像摄像头
     */
    useCamera() {
      this.videoShow = true;
      this.cameraOptions();
      this.pictureShow = false;
    },
    /**
     * 使用摄像头
     */
    cameraOptions() {
      let constraints = {
        video: {
          width: 400,
          height: 400,
        },
      };
      // 如果不是通过loacalhost或者通过https访问会将报错捕获并提示
      try {
        let video = document.getElementById("videoElement");
        let promise = navigator.mediaDevices.getUserMedia(constraints);
        promise
          .then((MediaStream) => {
            // 返回参数
            video.srcObject = MediaStream;
            video.play();
            this.recognizeFace();
          })
          .catch((error) => {
            console.log(error);
            alert("Primero habilite los permisos de la cámara en la configuración del navegador.");
          });
      } catch (err) {
        this.httpsAlert = `您现在在使用非Https访问，
                请先在chrome://flags/#unsafely-treat-insecure-origin-as-secure中修改配置,
                添将当前链接${window.location.href}添加到列表,
                并且将Insecure origins treated as secure修改为enabled,
                修改完成后请重启浏览器后再次访问！`;
      }
    },
    /**
     * 人脸识别方法
     * 通过canvas节点识别
     * 节点对象执行递归识别绘制
     */
    async recognizeFace() {
      let video = document.getElementById("videoElement");
      let canvas = document.getElementById("canvasElement");
      if (video.paused) return clearTimeout(this.interval);

      // 拍照按钮
      this.interval = setInterval(function() {
        canvas
          .getContext("2d", { willReadFrequently: true })
          .drawImage(video, 0, 0, 300, 150);
      }, 20);
    },
    /**
     * 拍照上传
     */
    async photoShoot() {
      // 拿到图片的base64
      let canvas = document
        .getElementById("canvasElement")
        .toDataURL("image/png");
      let video = document.getElementById("videoElement");
      // 拍照以后将video隐藏
      this.videoShow = false;
      this.pictureShow = true;
      // 停止摄像头成像
      video.srcObject.getTracks()[0].stop();
      video.pause();
      if (canvas) {
        // 拍照将base64转为file流文件
        let blob = this.dataURLtoBlob(canvas);
        console.log(blob);
        let file = this.blobToFile(blob, "imgName");
        console.info(file);
        // 将blob图片转化路径图片
        let image = window.URL.createObjectURL(file);
        this.picture = image;
        console.log(this.picture);
        // 将拍照后的图片发送给后端
        let formData = new FormData();
        formData.append("fs1", file);
        formData.append("fs1_size", 1);
        formData.append("access_token", localStorage.getItem("token"));
        this.$emit("openloading");
        liveVerify(formData).then(({ data }) => {
          if (data.code == 0) {
            this.$emit("complate");
          }
        });
        // axios({
        //   method: "post",
        //   url: "/user/12345",
        //   data: formData,
        // })
        //   .then((res) => {
        //     console.log(res);
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
      } else {
        console.log("canvas生成失败");
      }
    },
    /**
     * 将图片转为blob格式
     * dataurl 拿到的base64的数据
     */
    dataURLtoBlob(dataurl) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },
    /**
     * 生成文件信息
     * theBlob 文件
     * fileName 文件名字
     */
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date().toLocaleDateString();
      theBlob.name = fileName;
      return theBlob;
    },
  },
};
</script>

<style lang="scss" scoped>
#videoElement {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.videoImage {
  width: 4.1rem;
  height: 4.1rem;
  img {
    width: 4.1rem;
    height: 4.1rem;
  }
}
</style>
